import { css } from 'styled-components';

export const pxToRem = (px: number): string => {
  return `${px / 16}rem`;
};

export const slideInOut = css`
  &.slide-in {
    display: block;
    animation: slide-in 0.5s forwards;
  }
  &.slide-out {
    animation: slide-out 0.5s forwards;
  }
`;

export const boxShadow = css`
  box-shadow: 0 2px 6px -1px rgba(0, 0, 0, 0.25);
`;

export const flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const flexSpaceCenter = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const slideIn = (element: string): void => {
  document?.querySelector(element)?.classList.remove('slide-out');
  document?.querySelector(element)?.classList.add('slide-in');
};
export const slideBack = (element: string): void => {
  document.querySelector(element)?.classList.replace('slide-in', 'slide-out');
};

export const setBodyOverflow = (): void => {
  document.documentElement.scrollTop = 0;
  document.querySelector('body')?.classList.toggle('not-overflow');
};

export const removeOverflow = (): void => {
  document.querySelector('body')?.classList.remove('not-overflow');
  document.querySelector('body')?.classList.remove('prevent-overflow');
};

export const handleSectionMenu = (): void => {
  document.querySelector('#section-handler')?.classList.toggle('is-open');
  document.querySelector('.Menu')?.classList.toggle('is-open');
  document.querySelector('.app-container')?.classList.toggle('is-open');
  setBodyOverflow();
};

export const handleSidebarMenu = (): void => {
  document.querySelector('.Menu')?.classList.toggle('is-open');
  setBodyOverflow();
};

export const handleUserHeader = (): void => {
  document.querySelector('#user-hamburger')?.classList.toggle('is-open');
  document.querySelector('#user-links')?.classList.toggle('is-open');
  const userHeader = document.querySelector('#user-header');
  const sectionHandler = document.querySelector('#section-handler');
  const Menu = document.querySelector('.Menu');
  const Body = document.querySelector('body');
  const AppContainer = document.querySelector('.app-container');
  userHeader?.classList.toggle('is-menu-desplayed');
  Body?.classList.toggle('prevent-overflow');
  if (sectionHandler) {
    sectionHandler.classList.toggle('hide');
    sectionHandler.classList.remove('is-open');
    Menu?.classList.remove('is-open');
    Body?.classList.remove('not-overflow');
    AppContainer?.classList.remove('is-open');
  }
};

export const handleHelpSidebar = (): void => {
  document.querySelector('#help-sidebar')?.classList.toggle('is-open');
  const userHamburger = document.querySelector('#user-hamburger');
  const userLinks = document.querySelector('#user-links');
  const userHeader = document.querySelector('#user-header');
  if (userHamburger) {
    userHamburger.classList.remove('is-open');
  }
  if (userLinks) {
    userLinks.classList.remove('is-open');
  }
  if (userHeader) {
    userHeader.classList.remove('is-menu-desplayed');
  }
};

export const flexCenterColumn = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
